import { render, staticRenderFns } from "./EmProjectCardRouters.vue?vue&type=template&id=05d8d3e6&"
import script from "./EmProjectCardRouters.vue?vue&type=script&lang=js&"
export * from "./EmProjectCardRouters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports